import React from 'react';
import './styles.css';

/**
 * 表單輸入組件
 * 用於顯示帶有標籤的輸入框
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.id - 輸入框ID
 * @param {string} props.label - 輸入框標籤
 * @param {string} props.type - 輸入框類型
 * @param {string} props.value - 輸入框值
 * @param {Function} props.onChange - 值變更回調函數
 * @param {string} props.placeholder - 佔位符文本
 * @param {boolean} props.required - 是否必填
 * @param {string} props.error - 錯誤信息
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 表單輸入組件
 */
function FormInput({
    id,
    label,
    type = 'text',
    value,
    onChange,
    placeholder = '',
    required = false,
    error = '',
    className = '',
    ...rest
}) {
    return (
        <div className={`form-input ${error ? 'form-input-error' : ''} ${className}`}>
            {label && (
                <label htmlFor={id} className="form-input-label">
                    {label}
                    {required && <span className="form-input-required">*</span>}
                </label>
            )}
            <input
                id={id}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                className="form-input-field"
                {...rest}
            />
            {error && <div className="form-input-error-message">{error}</div>}
        </div>
    );
}

export default FormInput; 